// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"228":"8f5fb8db","433":"3f79fbf3"}[chunkId] + ".chunk.js";
};